import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as occupants from '../../../occupants'
import type { Collection } from '../collection'
import type { TypeParams } from '../types'

/**
 * When a responsible person is added to a space, this effect will also add the
 * responsible person as an occupant of the space. This ensures that the
 * responsible person has access to the space and can perform necessary actions
 * within it.
 */
export const addOccupantsWithResponsiblePersons = store.effects.create(
  (
    _: ec.Collection<TypeParams>['feature'],
    collection: Collection,
    occupantsEc: occupants.recordOccupants.Collection,
  ) =>
    collection.plugins.editingPlugin.feature.actions.submit.success
      .observe()
      .pipe(
        rxjs.mergeMap(action =>
          action.data.response.creations
            .filter(creation => TypeChecker.isTrue(creation.data.addOccupant))
            .map(({ data: { employeeIds } }) =>
              occupantsEc.plugins.dataOperationPlugin.feature.actions.create
                .from('(effect) add occupant with responsible person')
                .create({
                  input: { employeeIds },
                }),
            ),
        ),
      ),
)
